// @flow

import React, { Component } from "react";

import RadioHierarchyTree from "../../radio-hierarchy-tree";
import type { WidgetProps } from "@rjsf/utils";

type Props = $Exact<{
  ...WidgetProps,
  options: Object,
}>;

class RadioHierarchyTreeWidget extends Component<Props> {
  handleChange = (value: any): void => {
    this.props.onChange(value);
  };

  render() {
    return (
      <div className="schema-form-widget-radio-hierarchy-tree">
        <RadioHierarchyTree
          searchable={!!this.props.options.searchable}
          searchPlaceholder={this.props.options.searchPlaceholder}
          tree={this.props.schema.tree}
          selected={this.props.value}
          disabled={this.props.disabled}
          readOnly={this.props.readonly}
          onChange={this.handleChange}
          expanded={[]}
        />
      </div>
    );
  }
}

export default RadioHierarchyTreeWidget;
